export const caseStatus = [
  { title: 'Open', value: 'open' },
  { title: 'Closed', value: 'closed' },
]

export const uploadColumnMapping = [
  { key: 'provider_patient_id', title: 'Provider Patient ID', required: true },
  { key: 'patient_mr_number', title: 'Provider Patient Medical Record Number' },
  { key: 'case_id', title: 'Case ID', required: true },
  { key: 'service_date', title: 'Service Date', required: true },
  { key: 'discharge_date', title: 'Discharge Date' },
  { key: 'description', title: 'Description', required: true },
  { key: 'balance', title: 'Balance', required: true },
  { key: 'expected_bal_after_ins', title: 'Expected Balance After Insurance' },
  { key: 'patient_first_name', title: 'Patient First Name' },
  { key: 'patient_middle_name', title: 'Patient Middle Name' },
  { key: 'patient_last_name', title: 'Patient Last Name' },
  { key: 'patient_dob', title: 'Patient Date of Birth' },
  { key: 'patient_ssn', title: 'Patient SSN' },
  { key: 'patient_phone', title: 'Patient Phone Number' },
  { key: 'patient_email', title: 'Patient Email' },
  { key: 'patient_marital_status', title: 'Marital Status' },
  { key: 'patient_sex', title: 'Patient Sex' },
  { key: 'pat_address1', title: 'Patient Address 1' },
  { key: 'pat_address2', title: 'Patient Address 2' },
  { key: 'pat_city', title: 'Patient Address City' },
  { key: 'pat_state', title: 'Patient Address State' },
  { key: 'pat_zip', title: 'Patient Address Zip' },
  { key: 'pat_county', title: 'Patient Address County' },
  { key: 'icd10_code', title: 'ICD10 Code' },
  { key: 'physician_name', title: 'Physician Name' },
  { key: 'medication_ndcs', title: 'Medication Codes' },
]
